import { QuickFilterOption } from "../QuickFilterOption";
import { ProcessFilterZod, GroupBy, ProcessCountGroup, ArchivedFilter } from "@avenueops/shared-types";
import { TimeFrameArgs } from "context/ProcessTableContext";
import _ from "lodash";
import React from "react";
import Skeleton from "react-loading-skeleton";
import { trpc } from "utils/trpc";

interface Props {
  groupBy: GroupBy;
  timeFrameContext: TimeFrameArgs;
  filters?: ProcessFilterZod[];
  isFilterActive: (filter: ProcessFilterZod) => boolean;
  setQuickFilter: (filter: ProcessFilterZod) => void;
  clearQuickFilter: () => void;
  debouncedSearch?: any;
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export default function GenericQuickFilters({
  timeFrameContext,
  filters,
  isFilterActive,
  setQuickFilter,
  clearQuickFilter,
  debouncedSearch,
  groupBy,
  archived,
  isDashboard,
}: Props) {
  const { timeFrame, timeFrameStartIncl, timeFrameEndExcl } = timeFrameContext;

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const { data: processGroupCounts, isLoading } = trpc.processes.countByGroup.useQuery({
    filters: filters ?? [],
    groupBy,
    timeFrame,
    search: debouncedSearch ?? undefined,
    timeFrameStartIncl: timeFrameStartIncl?.toISOString(),
    timeFrameEndExcl: timeFrameEndExcl?.toISOString(),
    timeZone,
    archived,
    isDashboard,
  });

  return isLoading ? (
    <div className="mt-7 mb-5 w-full px-5 relative z-0">
      <Skeleton count={3} className="w-full mb-2 text-xl" />
    </div>
  ) : !processGroupCounts || processGroupCounts.length === 0 ? (
    <div className="my-5 text-sm text-gray-400 text-center w-full">No quick filters found</div>
  ) : (
    <div className="divide-y divide-gray-200 px-5">
      {processGroupCounts?.map((group: ProcessCountGroup, index: number) => (
        <div key={index}>
          <QuickFilterOption
            title={group.groupByTitle ?? "All"}
            active={isFilterActive(group.groupByfilterType as ProcessFilterZod)}
            enable={() => setQuickFilter(group.groupByfilterType as ProcessFilterZod)}
            disable={clearQuickFilter}
            count={group.count}
            clickable={true}
            totalCount={processGroupCounts?.reduce((total: number, group: ProcessCountGroup) => {
              return group.count + total;
            }, 0)}
          />
        </div>
      ))}
    </div>
  );
}
